export default {
      id: "i-lk-nav-rt-white-usage",
      viewBox: "0 0 7 7",
      url: __webpack_public_path__ + "img/sprite.svg#i-lk-nav-rt-white",
      toString: function () {
        return this.url;
      }
    }